<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="the-people-in-my-book">
<h1>The People in My Book</h1>
<div class="figure">
<img alt="C:\Users\Am\Pictures\PIC\1.jpg" src="Images/file1.jpg" style="width:3.20833in;height:1.88819in"/>
<p class="caption">C:\Users\Am\Pictures\PIC\1.jpg</p>
</div>
<p>Our regular Friday Night dinners at Liz’ and Nic’s Pub in the villa grounds. Most of the English, and other, people we met through the Pub dinners.</p>
<div class="section level3" id="nic-and-liz-owners-of-riverside-cottages-and-pub">
<h3><strong>Nic and Liz</strong> – owners of “Riverside Cottages” and Pub</h3>
</div>
<div class="section level3" id="section">
<h3></h3>
</div>
<div class="section level3" id="john-maintenance-man-and-some-time-barman-at-villas">
<h3><strong>John</strong> – Maintenance Man and some-time barman at Villas</h3>
</div>
<div class="section level3" id="section-1">
<h3></h3>
</div>
<div class="section level3" id="lucy-the-gardener-at-the-villas-she-owns-rosie">
<h3><strong>Lucy</strong> – the gardener at the Villas – she owns Rosie</h3>
</div>
<div class="section level3" id="section-2">
<h3></h3>
<p><strong>Andrea and Mark and Amy</strong> – English couple who live in the Villas – Mark works part time in London</p>
</div>
<div class="section level3" id="morat-the-scottish-upholsterer-and-some-time-cook-at-the-pub">
<h3><strong>Morat</strong> – the Scottish upholsterer and some-time cook at the Pub</h3>
</div>
<div class="section level3" id="section-3">
<h3></h3>
<p><strong>Mark</strong> – a Scottish art-dealer who sells art online from his home in the old main street</p>
<p><strong>Sue and John</strong> – bought a villa in Aubusson and fly over once a year for their annual holidays from Australia</p>
<p><strong>Tim and Linda</strong> – they have bought three villas in Aubusson</p>
<p><strong>Mr and Mrs ‘Caravan Dave’</strong> – an English couple who run a caravan in the UK and bought a villa here to renovate</p>
</div>
<div class="section level3" id="alan-a-single-man-who-bought-a-villa-here-and-renovates-other-english-peoples-villas-for-them">
<h3><strong>Alan</strong> – a single man who bought a Villa here and renovates other English people’s Villas for them</h3>
</div>
<div class="section level3" id="section-4">
<h3></h3>
<p><strong>Christa and Milan</strong> – a couple staying at the Villas – they are Serbian and South African and have an Aussie daughter</p>
<p><strong>Mark and Richard</strong> – staying in next Villa to ours – Alan from Doc Martin country (Cornwall)</p>
<p><strong>‘Henry VIII’ and Ann</strong> – Henry got that name as he has too many wives and children to remember all their names!</p>
<p><strong>Georgina</strong> – an English lady who is semi-retired to a tiny village outside of Aubusson – Mautes. She flies back to London to work on occasions</p>
<p><strong>Jacques</strong> – the devilish real estate agent in Aubusson – we call him ‘Black Adder’ because he dresses in all black</p>
<p><strong>Pauline and Ron –</strong> Georgina’s parents who work a sheep property in Mautes (in their 80’s)</p>
<p><strong>Our ‘first best friend’</strong> – she corners us in Aubusson lanes and wants to kiss us to look like she knows us Aussies well</p>
<p><strong>Our ’second best friend</strong>’ – who does the same as our ‘first best friend’</p>
</div>
<div class="section level3" id="rosie-the-gorgeous-dog-owned-by-lucy">
<h3><strong>Rosie</strong> – the gorgeous dog owned by Lucy</h3>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?7b12588d